import Styles from "./style.module.scss";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { handlerDeletePacketFromBasket } from "../../redux/Reducers/packetSlice";
import { Button } from "../../components/Button";
import PacketsInBasket from "./components/PacketsInBasket/PacketsInBasket";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const Basket: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { packetInBasket } = useAppSelector((state) => state.packets);
  const estimatedTotal = packetInBasket.reduce(
    (total, packet) => total + (Number.parseFloat(packet.price.replace(/[^0-9.]/g, "")) || 0),
    0
  );
  const packageCategory = packetInBasket[0]?.photosessionType.toLowerCase();
  const continueBrowsingPath = packageCategory ? `/prices/${packageCategory}/` : "/";

  const handlerClickDeletePacketFromBasket = (id: string) => {
    dispatch(handlerDeletePacketFromBasket(id));
  };

  return (
    <div className={Styles.basket}>
      <div className={Styles.basket__container}>
        {!packetInBasket.length ? (
          <p className={Styles.basket__notPackets}>Your selection is empty.</p>
        ) : (
          <div className={Styles.basket__wrapperTable}>
            <Link className={Styles.basket__backLink} to={continueBrowsingPath}>
              ← Continue browsing packages
            </Link>
            <h1 className={Styles.basket__title}>Your selection</h1>
            <p className={Styles.basket__description}>
              Review your package before sending a session request. No payment is required at this step.
            </p>
            <div className={Styles.basket__layout}>
              <PacketsInBasket
                onClickDeletePacket={handlerClickDeletePacketFromBasket}
                packetInBasket={packetInBasket}
              />
              <aside className={Styles.basket__checkout} aria-label="Request summary">
                <h2 className={Styles.basket__summaryTitle}>Request summary</h2>
                <ul className={Styles.basket__summaryPackages}>
                  {packetInBasket.map((packet) => (
                    <li key={packet._id}>
                      <span>{packet.namePacket}</span>
                      <span>${packet.price}</span>
                    </li>
                  ))}
                </ul>
                <div className={Styles.basket__total}>
                  <span>Estimated total</span>
                  <strong>${estimatedTotal}</strong>
                </div>
                <Button
                  styleButton="ping"
                  editStyle="buttonBasket"
                  edit
                  type="button"
                  onClick={() => navigate("/checkout/")}
                >
                  Continue to session request
                </Button>
                <p className={Styles.basket__paymentNote}>You won’t be charged today</p>
              </aside>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Basket;
